export interface IOpsScheduleDay {
    id: number,
    startTime: string,
    endTime: string,
    displayOrder: number
}